import React, { useState, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import AddUser from "./Assets/AddForm";
import EditForm from "./Assets/EditForm";
import DeleteUser from "./Assets/DeleteModal";
import ViewUser from "./Assets/ViewModel";
import { Eye } from "lucide-react";
import { MdDeleteOutline } from "react-icons/md";
import { TbEdit,TbEye } from "react-icons/tb";

const UserDetails = () => {
  const [packageData, setPackageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [addUserModel, setAddUserModel] = useState(false);
  
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [editFormModel, setEditFormModel] = useState(false);
    const [itemToEdit, setItemToEdit] = useState(null);
      const [viewUserModel, setViewUserModel] = useState(false);
      const [itemToView, setItemToView] = useState(null);
  const itemsPerPage = 10;

  const Auth = localStorage.getItem("authToken");
    const userRole = localStorage.getItem("UserRole");

  useEffect(() => {
    fetchPackageData();
  }, []);
  const fetchPackageData = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/package/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      
      
      const result = await response.json();
      if (!result.success) throw new Error("Failed to fetch form data");
      setPackageData(result.data || []);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredPackageData = useMemo(() => {
    const today = new Date();
    let filtered = packageData.filter((u) => {
      const nameMatch = u.packageName?.toLowerCase().includes(search.toLowerCase()) ;
      

      return nameMatch ;
    });

    
    

    return filtered;
  }, [packageData, search]);

  // Pagination Method
  const totalPages = Math.ceil(filteredPackageData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPackageData = filteredPackageData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  const handleAddUserClick = () => {
    setAddUserModel(true);
  };

  const cancelAddUser = () => {
    setAddUserModel(false);
  };
  
    const confirmAddUser = async (formData) => {
    try {
       
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/package/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
        body: JSON.stringify(formData),  
      });

      const result = await response.json();
      if (!result.success) {
        toast.error(result.message || "Delete failed");
        return;
      }
        toast.success(result.message); 
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
    fetchPackageData();
    setAddUserModel(false);
  };


  
    const handleEditFormClick = (user) => {
      setItemToEdit(user);
      setEditFormModel(true);
    };
  
    const cancelEditForm = () => {
      setEditFormModel(false);
      setItemToEdit(null);
    };
  
    const confirmEditForm = async (formData) => {
      try {
  
        const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/package/edit/${itemToEdit.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Auth}`,
          },
          body: JSON.stringify(formData), 
        });
  
        const errorText = await response.json();
        if (!errorText.success) {
          
          toast.error(errorText.message || "User Updated Successfully");
          throw new Error(`Failed to save user: ${errorText}`);
        }else{
          toast.success(errorText.message || "User Updated Successfully");
        }
      } catch (error) {
        //console.error("Something went wrong");
      }
      fetchPackageData();
      setEditFormModel(false);
      setItemToEdit(null);
    };
  
    const handleDeleteClick = (id) => {
      setItemToDelete(id);
      setDeleteModalShow(true);
    };
  
    const confirmDelete = async () => {
      try {
  
  
        const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/package/delete/${itemToDelete}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Auth}`
          }  
        });
  
        const errorText = await response.json();
        if (!errorText.success) {
  
          toast.error(`${errorText.message} (Tasks: ${errorText.task_count}, Logs: ${errorText.log_count})` || "Failed to delete user");
          throw new Error(`Failed to delete user: ${errorText}`);
        }else{
          toast.success(errorText.message || "User deleted successfully");
        }
      } catch (error) {
        //console.error("Something went wrong");
      }
      fetchPackageData();
      setDeleteModalShow(false);
      setItemToDelete(null);
    };
  
    const cancelDelete = () => {
      setDeleteModalShow(false);
      setItemToDelete(null);
    };


        const handleViewClick = (item) => {
      setItemToView(item);
      setViewUserModel(true);
    };



        const cancelView = () => {
      setViewUserModel(false);
      setItemToView(null);
    };
  
  
 
  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Packages Details</h2>
      <div className="flex justify-between items-center mb-4">
        <div className="user-heading">
          <button className="text-sm font-normal bg-blue-500 p-2 rounded text-white cursor-pointer" onClick={() => handleAddUserClick()}>Add New Package</button> 
        </div>
      
        <div className="flex justify-end flex-wrap gap-4 mb-4">
          <input
            type="text"
            placeholder="Search by module name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="px-4 py-2 border rounded"
          />
          

          
        </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Package Name</th>
            <th className="px-4 py-2 text-left">Package Details</th>
            <th className="px-4 py-2 text-left">Package Duration</th>
            <th className="px-4 py-2 text-left">Modules Name</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPackageData.length > 0 ? (
            currentPackageData.map((f, index) => (
              <tr key={f.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2"><div className="flex items-center space-x-2">{f.packageName || "N/A"}</div></td>
                <td className="px-4 py-2">{f.packageDetails || "N/A"}</td>
                <td className="px-4 py-2">{f.packageDuration || "N/A"}</td>
                <td className="px-4 py-2">{f.modules?.length > 0
                  ? [...new Set(f.modules.map((module) => module.moduleName))].join(", ")
                  : "N/A"}
                </td>
                <td className="px-4 py-2 flex gap-2">
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleViewClick(f)}>
                                      <TbEye size={22}  />
                                    </button>
                                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleEditFormClick(f)}>
                                    <TbEdit size={22} />
                                  </button> 
                                  <button className="text-red-500 hover:text-red-700" onClick={() => handleDeleteClick(f.id)}>
                                    <MdDeleteOutline size={22} />
                                  </button>
                                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No form data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      {addUserModel && (
        <AddUser
          
          onClose={cancelAddUser}
          onSubmit={(formData) => confirmAddUser(formData)}
        />
      )}

      {deleteModalShow && (
        <DeleteUser
          itemName={
            currentPackageData.find((p) => p.id === itemToDelete)?.packageName || "Unknown Package"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}

      {editFormModel && (
              <EditForm
                user={itemToEdit}
                onClose={cancelEditForm}
                onEdit={(formData) => confirmEditForm(formData)}
              />
            )}

      {viewUserModel && (
        <ViewUser
          user={itemToView}
          onClose={cancelView}
        />
      )}
      
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
